export const validation = {
  titleMaxChar: 100,
  title: { required: true },
  buttons: {
    min: 0,
    max: 2
  }
}
